package io.github.jangalinski.pages._2014._12._08

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initStreamingFromDropboxPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/12/08/StreamingFromDropbox.md", FrontMatterElement.Builder { addScalar("title", "Streaming from dropbox"); addScalar("subtitle", "Build a little mans youtube"); addScalar("description", "How you can use the dropbox public directory as a streaming infrastructure instead of using youtube, vimeo and so on."); addScalar("header-img", "/img/about-bg.jpg"); addScalar("date", "2014-12-08"); }))
}

@Page("/2014/12/08/streaming-from-dropbox")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun StreamingFromDropboxPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I was looking for a simple solution to provide some private family videos (it's this time of the year again) without uploading them to a video streaming platform and forcing my parents to log in with a google account to see their grandchildren singing christmas songs.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I already offered those video with some php-cms on my shared server, but since streaming is not supported, the whole video had to be downloaded before the player started.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I searched a bit and found the solution on ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.lockergnome.com/media/2012/06/26/how-use-dropbox-host-stream-videos/") {
            org.jetbrains.compose.web.dom.Text("lockergnome")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It is extremely easy:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("convert your video to mp4 (I used \"permute\" for this).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Move the video to ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("/Dropbox/public")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("right click the video and copy the public link")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("enter some HTML5 code in your page, using the link you just copied to the clipboard.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("you are done.")
        }
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""<videowidth="512" height="288" controls="controls">
<source src="https://www.dropbox.com/s/os60r63ogwfl408/your_video_here.mp4" type="video/mp4" />
</video>
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Nice, clean, simple (ok, I used one american file hoster instead of an american video portal) and I can just remove the vids any time with a simple keystroke.")
    }
}
